import { Popover } from '@mui/material';
import { ColorResult, SketchPicker } from 'react-color';
import { useState, useEffect } from 'react';
import { ChartColorsProps } from '../ChartColors';

interface ColorPickerPopoverProps {
  isOpen: boolean;
  onClose: () => void;
  currentColor: string;
  anchorEl: HTMLElement | null;
  onColorChange: (color: string) => void;
  propKey?: string;
  onBackgroundColorChange?: ChartColorsProps['onBackgroundColorChange'];
  selectedMenu?: string;
}

const ColorPickerPopover = ({
  isOpen,
  onClose,
  currentColor,
  anchorEl,
  onColorChange,
  onBackgroundColorChange,
  selectedMenu,
}: ColorPickerPopoverProps) => {
  const [localColor, setLocalColor] = useState(currentColor);

  useEffect(() => {
    setLocalColor(currentColor);
  }, [currentColor]);

  return (
    <Popover
      open={isOpen}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
    >
      <div style={{ padding: '0px' }}>
        <SketchPicker
          color={localColor}
          className="sketchPicker"
          width="16rem"
          disableAlpha
          onChange={(color: ColorResult) => {
            setLocalColor(color.hex);
          }}
          onChangeComplete={(color: ColorResult) => {
            onColorChange(color.hex);
            if (onBackgroundColorChange && selectedMenu) {
              onBackgroundColorChange({
                schemeName: selectedMenu,
                color: color.hex,
              });
            }
          }}
        />
      </div>
    </Popover>
  );
};

export default ColorPickerPopover;
